import React, { useState, useEffect } from 'react'
import './styles.scss'
import Button from 'components/Button'
import CartItem from 'features/Shop/components/CartItem'
import { useCartContext } from 'context/shop/CartProvider'
import { Link } from 'react-router-dom'
import { numberWithCommas } from 'utils/priceConvert'
import CartNotFound from 'assets/shop/empty_cart 1.png'

function ShopCart() {
  const { cartItems } = useCartContext()
  const [totalPrice, setTotalPrice] = useState(0)
  const [isEmpty, setisEmpty] = useState(false)

  useEffect(() => {
    setTotalPrice(
      cartItems.reduce((total, item) => total + Number(item.quantity) * Number(item.price), 0)
    )
    if (cartItems.length === 0) {
      setisEmpty(true)
    }
  }, [cartItems])

  return (
    <div className="cart">
      <span className="cart__title">Cart</span>
      {isEmpty ? (
        <div className="cart__not-found">
          <img src={CartNotFound} alt="" />
          <span className="cart__not-found__content">There are no products in your cart</span>
          <div className="cart__not-found__btn">
            <Link to={'/shop'}>
              <Button
                size="xl"
                fontSize="h6"
                backgroundColor="custom"
                color="color"
                borderRadius="cart"
              >
                CONTINUE SHOPPING
              </Button>
            </Link>
          </div>
        </div>
      ) : (
        <div className="cart__container">
          <div className="cart__container__left">
            <hr className="cart__container__line-top" />
            <span className="cart__container__left__product">Product</span>
            <span className="cart__container__left__quantity">Quantity</span>
            <span className="cart__container__left__total">Total</span>
            <span className="cart__container__left__remove">Remove</span>
            <hr className="cart__container__line-bottom" />
            <div>
              {cartItems.map((item, index) => (
                <CartItem item={item} key={index} />
              ))}
            </div>
            <hr className="cart__container__line-bottom" />
            <div className="cart__container__left__btn">
              <Link to={'/shop'}>
                <Button
                  size="xl"
                  fontSize="h6"
                  backgroundColor="custom"
                  color="color"
                  borderRadius="cart"
                >
                  CONTINUE SHOPPING
                </Button>
              </Link>
            </div>
          </div>

          <div className="cart__container__right">
            <div className="cart__container__right__top">
              <span className="cart__container__right__top__total">Total</span>
              <span className="cart__container__right__top__price">
                ${numberWithCommas(Number(totalPrice))}
              </span>
            </div>
            <hr className="cart__container__right__line" />
            <div className="cart__container__right__bottom">
              <Link to={'/checkout'}>
                <Button
                  size="mn"
                  fontSize="h6"
                  backgroundColor="custom"
                  color="color"
                  borderRadius="cart"
                >
                  PAYMENT
                </Button>
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
export default ShopCart
